import { useEffect } from "react";
import { api } from "./api";

const GA_ID = process.env.REACT_APP_GA_ID;
export const getConsent = () => localStorage.getItem("cc_consent");

export function loadGA() {
  if (!GA_ID || getConsent() !== "all" || window.gtag) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID);
}

export function track(event, data = {}) {
  if (getConsent() !== "all") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
  if (window.gtag) window.gtag("event", event, data);
  if (event === "PageView" || event === "AddToCart") api.post("/track", { event, path: data.path || "" }).catch(() => {});
}

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content || "");
}

export function useSeo({ title, description, image, jsonLd }) {
  useEffect(() => {
    const full = title ? `${title} | Cloud Center Costa Rica` : "Cloud Center Costa Rica | Software empresarial y plataformas SaaS";
    document.title = full;
    const desc = description || "Desarrollo de software empresarial, plataformas SaaS, integraciones y soluciones cloud en Costa Rica y Latinoamérica.";
    setMeta("name", "description", desc);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", window.location.href);
    if (image) setMeta("property", "og:image", image);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = window.location.origin + window.location.pathname;
    let ld = document.getElementById("ld-json");
    if (jsonLd) {
      if (!ld) {
        ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "ld-json";
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) ld.remove();
  }, [title, description, image, jsonLd]);
}
